import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import CustomDataTable from "../../../../../../partials/content/CustomDataTable";
import DialogLayout from "../../../../../../partials/content/DialogLayout";
import Illustration from "../../../../../../partials/content/Illustration";
import {
  getItemsTransfer,
  cancelItemsTransfer,
} from "../../../../../../services/inventory/itemsMovement";
import { formatDate } from "../../../../../../utils/utils";
import ItemsTransferDetail from "./itemsTransferDetail";
import ItemsTransferForm from "./itemsTransferForm";
import { Badge } from "react-bootstrap";
import ResponsiveEllipsis from "../../../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../../../partials/content/BootstrapTooltip";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../../../provider/GlobalDataProvider";
function ItemsTransferList({
  warehouseID: warehouseIDprop = 0,
  outletID: outletIDprop = 0,
  match,
}) {
  const { reload } = useGlobalData();
  let warehouseID = 0;
  let outletID = 0;
  if (warehouseIDprop > 0) {
    warehouseID = warehouseIDprop;
  } else {
    const { warehouseID: warehouseIDparam = 0 } = match.params;
    warehouseID = warehouseIDparam;
  }

  if (outletIDprop > 0) {
    outletID = outletIDprop;
  } else {
    const { outletID: outletIDparam = 0 } = match.params;
    outletID = outletIDparam;
  }
  const [itemsTransfer, setItemsTransfer] = useState([]);
  const [openItemsTransferForm, setOpenItemsTransferForm] = useState(false);
  const [transferID, setTransferID] = useState(0);
  const [openItemsTransferDetail, setOpenItemsTransferDetail] = useState(false);
  const [warehouse, setWarehouse] = useState({ ID: 0, warehouseName: "" });
  const [outlet, setOutlet] = useState({ ID: 0, outletName: "" });
  useEffect(() => {
    getItemsTransferData(warehouseID, outletID);
  }, [warehouseID, outletID, reload]);

  const itemTransferDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      {itemsTransfer.length ? (
        <React.Fragment>
          <CustomDataTable
            buttons={[
              {
                name: "New Items Transfer",
                onClick: () => {
                  setOpenItemsTransferForm(true);
                },
                icon: "fas fa-plus-circle",
                color: "primary",
              },
            ]}
            data={itemsTransfer}
            dataDetailColumns={itemTransferDetailColumn}
            onRefreshData={() => {
              getItemsTransferData(warehouseID, outletID);
            }}
            columns={[
              {
                header: "Transfer ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Destination Type",
                field: "toLocationType",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.toLocationType}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Destination Location",
                field: "toLocation",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.toLocation} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Goods Receive Status",
                field: "grStatusDesc",
                body: (rowData) => {
                  if (rowData.grStatus === 1) {
                    return (
                      <Badge variant="primary">{rowData.grStatusDesc}</Badge>
                    );
                  } else if (rowData.grStatus === 2) {
                    return (
                      <Badge variant="warning">{rowData.grStatusDesc}</Badge>
                    );
                  } else if (rowData.grStatus === 3) {
                    return (
                      <Badge variant="success">{rowData.grStatusDesc}</Badge>
                    );
                  } else if (rowData.grStatus === 9) {
                    return (
                      <Badge variant="danger">{rowData.grStatusDesc}</Badge>
                    );
                  } else {
                    return <Badge variant="dark">{rowData.grStatusDesc}</Badge>;
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Movement Date",
                field: "moveDate",
                body: (rowData) => formatDate(rowData.moveDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Transfer Cost Total",
                field: "totalCost",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.totalCost}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Items Transfer Detail">
                      <button
                        type="button"
                        onClick={() => {
                          setTransferID(rowData.ID);
                          setOpenItemsTransferDetail(true);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                    {rowData.grStatus === 1 ? (
                      <BootstrapTooltip title="Delete Items Transfer">
                        <button
                          type="button"
                          className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                          onClick={() => {
                            cancelItemsTransferData(rowData.ID);
                          }}
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Inventory.png"
            description="Hooray! You're ready to have your first Items Transfer from this warehouse!"
            guidance="Hint: manage your items transfer from one warehouse to another to maximize collaboration"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                setOpenItemsTransferForm(true);
              }}
            >
              <i className="fas fa-plus-circle"></i>
              New Items Transfer
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openItemsTransferForm}
        title="Items Transfer Form"
        onCloseDialog={() => {
          setOpenItemsTransferForm(false);
        }}
        fullScreen={false}
      >
        {warehouse.ID > 0 || outlet.ID > 0 ? (
          <ItemsTransferForm
            accessedFrom="IND"
            warehouse={warehouse}
            outlet={outlet}
            onCloseDialog={() => {
              setOpenItemsTransferForm(false);
            }}
            onConfirmSave={() => {
              setOpenItemsTransferForm(false);
              getItemsTransferData(warehouseID, outletID);
            }}
          />
        ) : null}
      </DialogLayout>
      <DialogLayout
        open={openItemsTransferDetail}
        title="Items Transfer Detail"
        onCloseDialog={() => {
          setOpenItemsTransferDetail(false);
        }}
        minHeight={true}
      >
        <ItemsTransferDetail
          transferID={transferID}
          onCloseDialog={() => {
            setOpenItemsTransferDetail(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function cancelItemsTransferData(transferID) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Items Transfer ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelItemsTransfer(transferID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getItemsTransferData(warehouseID, outletID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getItemsTransferData(warehouseID, outletID) {
    const response = await getItemsTransfer(warehouseID, outletID);
    const { data } = response.data;
    setItemsTransfer(data.itemsTransfer);
    setWarehouse(data.warehouse);
    setOutlet(data.outlet);
  }
}

export default ItemsTransferList;
